import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=23a34cca"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlockHeaderProduct: require('/var/www/html/fantini/frontend-2/components/block/header/product/index.vue').default,BlocksWrapper: require('/var/www/html/fantini/frontend-2/components/blocks-wrapper/index.vue').default,BlockRecirculationProducts: require('/var/www/html/fantini/frontend-2/components/block/recirculation/products/index.vue').default,BlockGridCertifications: require('/var/www/html/fantini/frontend-2/components/block/grid/certifications/index.vue').default,BlockBtnGroupSolid: require('/var/www/html/fantini/frontend-2/components/block/btn/group/solid/index.vue').default,BlockRecirculationApplications: require('/var/www/html/fantini/frontend-2/components/block/recirculation/applications/index.vue').default,BlockCardLauncherNormal: require('/var/www/html/fantini/frontend-2/components/block/card/launcher/normal/index.vue').default,BlockGalleryMultiratio: require('/var/www/html/fantini/frontend-2/components/block/gallery/multiratio/index.vue').default,BlockGallerySlide: require('/var/www/html/fantini/frontend-2/components/block/gallery/slide/index.vue').default,Page: require('/var/www/html/fantini/frontend-2/components/page/index.vue').default})
